import { UserRole } from 'src/types';

export type UserRoleLabels = Record<UserRole, string>;
export const USER_ROLE_LABELS: UserRoleLabels = {
  employee: 'Employee',
  admin: 'Admin',
  superadmin: 'Superadmin',
} as const;
